import React from "react";
import styles from "../pages/About.module.css";

import CompanyDescription from "../components/CompanyDescription";
import BackToTop from "../components/BackToTop";
import StatsSection from "../components/StatsSection";

const About: React.FC = () => {
  return (
    <main className={styles.aboutPage}>
      <CompanyDescription />
      <StatsSection />

      <BackToTop />
    </main>
  );
};
export default About;
